interface BuildOfferShareTextParams {
  title: string;
  location: string;
  condition: string;
  quantity: string;
  price?: string;
  description?: string;
  contactName?: string;
  contactPhone?: string;
  t: (key: string, options?: Record<string, string | number>) => string;
}

export function buildOfferShareHandoffUrl(origin: string, offerId: string): string {
  const url = new URL('/share/offer', origin);
  url.searchParams.set('offerId', offerId);
  return url.toString();
}

export function buildParentAppContinuationUrl(
  parentAppHandoffBaseUrl: string,
  targetPath: string
): string {
  if (parentAppHandoffBaseUrl.includes('{redirect}')) {
    return parentAppHandoffBaseUrl.replace('{redirect}', encodeURIComponent(targetPath));
  }

  const url = new URL(parentAppHandoffBaseUrl);
  url.searchParams.set('redirect', targetPath);
  return url.toString();
}

export function buildOfferShareText({
  title,
  location,
  condition,
  quantity,
  price,
  description,
  contactName,
  contactPhone,
  t,
}: BuildOfferShareTextParams): string {
  const lines = [
    t('offerDetail.shareIntro', { title }),
    `${t('offerDetail.shareFields.location')}: ${location}`,
    `${t('offerDetail.shareFields.condition')}: ${condition}`,
    `${t('offerDetail.shareFields.quantity')}: ${quantity}`,
  ];

  if (price) {
    lines.push(`${t('offerDetail.shareFields.price')}: ${price}`);
  }
  if (description) {
    lines.push(`${t('offerDetail.shareFields.description')}: ${description}`);
  }
  if (contactName) {
    lines.push(`${t('offerDetail.shareFields.contact')}: ${contactName}`);
  }
  if (contactPhone) {
    lines.push(`${t('offerDetail.shareFields.phone')}: ${contactPhone}`);
  }
  return lines.join('\n');
}

export async function fileToDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export async function fetchImageAsFile(url: string): Promise<File | null> {
  try {
    const response = await fetch(url);
    if (!response.ok) return null;
    const blob = await response.blob();
    const type = blob.type || 'image/jpeg';
    const ext = type.split('/')[1] || 'jpg';
    return new File([blob], `offer-photo.${ext}`, { type });
  } catch {
    return null;
  }
}

export async function fetchShareFile(photoUrl: string): Promise<File | null> {
  //if (!('share' in navigator)) return null;
  const file = await fetchImageAsFile(photoUrl);
  if (!file /* || !navigator.canShare({ files: [file] }) */) return null;
  return file;
}

export async function copyToClipboard(text: string): Promise<void> {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  textarea.style.top = '0';
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  const copied = document.execCommand('copy');
  document.body.removeChild(textarea);

  if (!copied) {
    throw new Error('Clipboard copy failed');
  }
}
